import { useNavigate } from 'react-router-dom';

import FolderFormComponent from '../features/folders/components/folderForm/FolderFormComponent';
import FolderFormHeader from '../features/folders/components/folderForm/FoldersFormHeader';
import './styles/MyFoldersFormPage.scss';

function FolderFormPage() {
  const navigate = useNavigate();

  const handleCancel = () => navigate('/mes-dossiers');

  return (
    <main className="my-folders-form-page">
      <FolderFormHeader />
      <section className="my-folders-form-page-content">
        <FolderFormComponent handleCancel={handleCancel} />
      </section>
    </main>
  );
}

export default FolderFormPage;
